<template>
  <div class="flex flex-col items-center justify-center h-full min-h-[500px] w-full">
    <div class="relative flex flex-col items-center">
      <!-- Efecto de Halo/Ring Giratorio -->
      <div class="absolute -inset-4 rounded-full border-t-2 border-l-2 border-cyan-500/30 animate-spin-slow"></div>
      <div class="absolute -inset-4 rounded-full border-r-2 border-b-2 border-teal-500/30 animate-spin-reverse"></div>
      
      <!-- Contenedor del Logo con Sombra/Glow -->
      <div class="relative z-10 p-6 bg-white rounded-2xl shadow-[0_0_40px_-10px_rgba(6,182,212,0.3)] animate-float">
        <img src="@/assets/isotipo.png" alt="Zentry" class="h-16 w-16 object-contain" />
      </div>
      
      <!-- Texto y Loader de Puntos -->
      <div class="mt-8 flex flex-col items-center">
        <h3 class="text-lg font-bold bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent tracking-wide">
          ZENTRY
        </h3>
        <div class="flex space-x-1.5 mt-3">
          <div class="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-bounce" style="animation-delay: 0s"></div>
          <div class="w-1.5 h-1.5 bg-cyan-500 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
          <div class="w-1.5 h-1.5 bg-cyan-600 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.animate-spin-slow {
  animation: spin 3s linear infinite;
}
.animate-spin-reverse {
  animation: spin-reverse 4s linear infinite;
}
.animate-float {
  animation: float 3s ease-in-out infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes spin-reverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
</style>
